import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";

export default function NoObjectionCertificate({ branchData, student: payee }) {
  const printRef = useRef();

  const [formData, setFormData] = useState({
    name:
      [payee?.firstName, payee?.middleName, payee?.lastName]
        .filter(Boolean)
        .join(" ") ||
      payee?.vendorName ||
      payee?.name ||
      "",
    course: payee?.selectedCourse || payee?.serviceScope || "Supply Chain & Infrastructure Services",
    examCourse: "AUDIT & DUES RELEASE",
    examMonth: "DECEMBER",
    examYear: "2026",
    feesCompletion: "PAID IN FULL / CLEARED",
    date: new Date().toLocaleDateString("en-GB"),
    place: "Bangalore",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>NO OBJECTION CERTIFICATE</title>
          <style>
            body {
              font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
              padding: 40px;
              color: #222;
            }

            .header {
              width: 100%;
              text-align: center;
              margin-bottom: 10px;
            }

            .logo {
              display: block;
              width: 80px;
              margin: 0 auto 5px auto;
            }

            .title-main,
            .title-sub {
              width: 100%;
              text-align: center;
              font-weight: bold;
            }

            .title-main {
              font-size: 20px;
              letter-spacing: 0.5px;
            }

            .title-sub {
              font-size: 15px;
              margin-bottom: 15px;
            }

            .field-row {
              margin: 20px 0;
              font-size: 15px;
            }

            .label {
              display: inline-block;
              width: 250px;
              font-weight: bold;
            }

            .line {
              display: inline-block;
              border-bottom: 1px dotted #000;
              width: 55%;
              height: 18px;
            }

            .footer {
              margin-top: 60px;
            }

            .left {
              float: left;
            }

            .right {
              float: right;
              font-weight: bold;
              text-align: right;
            }

            .clear {
              clear: both;
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">
      {/* PRINT AREA */}
      <div ref={printRef}>
        {branchData?.logoUrl && (
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <img src={branchData.logoUrl} style={{ width: "80px" }} alt="Corporate Logo" />
          </div>
        )}
        <div className="title-main">GLOBAL LOGISTICS & MANUFACTURING CORP</div>

        <div className="title-sub">
          NO OBJECTION & FINANCIAL CLEARANCE CERTIFICATE FOR{" "}
          {formData.examCourse} - {formData.examMonth} {formData.examYear}
        </div>

        <div className="field-row">
          <span className="label">VENDOR / CONTRACTOR NAME</span> :
          <span className="line">{formData.name}</span>
        </div>

        <div className="field-row">
          <span className="label">SERVICE SCOPE / PROJECT</span> :
          <span className="line">{formData.course}</span>
        </div>

        <div className="field-row">
          <span className="label">FINANCIAL / DUES CLEARANCE</span> :
          <span className="line">{formData.feesCompletion}</span>
        </div>

        <div className="footer">
          <div className="left">
            <div>Date : {formData.date}</div>
            <div>Place : {formData.place}</div>
          </div>

          <div className="right">
            AUTHORIZING CONTROLLER / AUDIT OFFICER
          </div>
          <div className="clear"></div>
        </div>
      </div>

      {/* EDIT FORM */}
      <Form className="mt-4 border-top pt-4">
        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Vendor / Payee Name</Form.Label>
              <Form.Control
                placeholder="Vendor / Payee Name"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Service Scope / Project</Form.Label>
              <Form.Control
                placeholder="Service Scope / Project"
                value={formData.course}
                onChange={(e) => handleChange("course", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Clearance Type</Form.Label>
              <Form.Control
                placeholder="Clearance Type (e.g. Audit / Release)"
                value={formData.examCourse}
                onChange={(e) => handleChange("examCourse", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Period / Month</Form.Label>
              <Form.Control
                placeholder="Month (DECEMBER)"
                value={formData.examMonth}
                onChange={(e) =>
                  handleChange("examMonth", e.target.value.toUpperCase())
                }
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Fiscal Year</Form.Label>
              <Form.Control
                placeholder="Year"
                value={formData.examYear}
                onChange={(e) => handleChange("examYear", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Financial / Dues Clearance Status</Form.Label>
              <Form.Control
                placeholder="Clearance Status (e.g., CLEARED)"
                value={formData.feesCompletion}
                onChange={(e) => handleChange("feesCompletion", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Issue Date</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const formatted = new Date(value).toLocaleDateString("en-GB");
                    handleChange("date", formatted);
                  }
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Location / Place</Form.Label>
              <Form.Control
                placeholder="Place"
                value={formData.place}
                onChange={(e) => handleChange("place", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Button onClick={handlePrint} className="mt-3" variant="primary">
          Print No Objection Certificate
        </Button>
      </Form>
    </Container>
  );
}